import { render, staticRenderFns } from "./code-check.vue?vue&type=template&id=e666c326&scoped=true&"
import script from "./code-check.vue?vue&type=script&lang=js&"
export * from "./code-check.vue?vue&type=script&lang=js&"
import style0 from "./code-check.vue?vue&type=style&index=0&id=e666c326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e666c326",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
